import React from 'react';
import { useNavigate } from 'react-router-dom';

const HarmonyIntro = () => {
  const navigate = useNavigate();

  return (
    <div className="harmony-container harmony-shell">
      <div className="harmony-card harmony-mobile-card">
        <div className="harmony-icon">
          <span className="heart">o</span>
          <span className="plus">+</span>
          <span className="heart">o</span>
        </div>

        <h1 className="title">How well do you match?</h1>
        <p className="subtitle">Harmony & Chemistry Analysis</p>

        <div className="funnel-summary">
          <div className="funnel-step">
            <strong>1</strong>
            <span>Enter the other ID</span>
          </div>
          <div className="funnel-step">
            <strong>2</strong>
            <span>See the compatibility score</span>
          </div>
          <div className="funnel-step">
            <strong>3</strong>
            <span>Read the action guide</span>
          </div>
        </div>

        <div className="intro-content">
          <p>
            This flow focuses on attraction direction, friction risk, and overall match quality.
            <br />
            <strong>The first mobile screen is built to move people into the next step quickly.</strong>
          </p>
        </div>

        <div className="action-buttons">
          <button
            className="start-btn primary"
            onClick={() => navigate('/harmony/select')}
          >
            Start compatibility analysis
          </button>
          <button
            className="start-btn secondary"
            onClick={() => navigate('/')}
          >
            Back to home
          </button>
        </div>
      </div>

      <style jsx>{`
        .harmony-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: var(--mobile-shell-padding-top) var(--mobile-shell-padding-x) var(--mobile-shell-padding-bottom);
          background: radial-gradient(circle at top left, #2e1065, #0f172a),
            radial-gradient(circle at bottom right, #4c1d95, #0f172a);
          color: white;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        .harmony-card {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 32px;
          padding: 1.4rem 1rem;
          text-align: center;
          max-width: var(--mobile-shell-max);
          width: 100%;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        }

        .harmony-icon {
          font-size: 2.2rem;
          margin-bottom: 1.1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        }

        .heart {
          filter: drop-shadow(0 0 10px rgba(236, 72, 153, 0.5));
        }

        .plus {
          color: #94a3b8;
          font-size: 1.2rem;
          font-weight: 300;
        }

        .title {
          font-size: var(--mobile-title-lg);
          font-weight: 800;
          margin-bottom: 0.75rem;
          background: linear-gradient(to right, #f472b6, #fb7185, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          letter-spacing: -0.02em;
        }

        .subtitle {
          color: #94a3b8;
          font-size: 0.88rem;
          font-weight: 500;
          margin-bottom: 1rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
        }

        .funnel-summary {
          display: grid;
          grid-template-columns: 1fr;
          gap: 0.6rem;
          margin-bottom: 1rem;
        }

        .funnel-step {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.8rem 0.9rem;
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.08);
          text-align: left;
        }

        .funnel-step strong {
          width: 26px;
          height: 26px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 999px;
          background: rgba(244, 114, 182, 0.18);
          color: #fbcfe8;
          font-size: 0.84rem;
        }

        .funnel-step span {
          color: #e2e8f0;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .intro-content {
          margin-bottom: 1rem;
          line-height: 1.8;
          font-size: 1rem;
          color: #cbd5e1;
          text-align: left;
        }

        .intro-content strong {
          color: #f472b6;
          font-weight: 700;
        }

        .action-buttons {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .start-btn {
          width: 100%;
          min-height: var(--mobile-button-height);
          padding: 1rem;
          font-size: 1rem;
          font-weight: 700;
          border-radius: 18px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
        }

        .start-btn.primary {
          color: white;
          background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%);
          box-shadow: 0 10px 20px -5px rgba(236, 72, 153, 0.4);
        }

        .start-btn.secondary {
          color: #e2e8f0;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
      `}</style>
    </div>
  );
};

export default HarmonyIntro;
